// utility file
const colors = {
  light: {
    mainBg: 'rgb(255, 255, 255)',
    sidebarBg: 'rgba(255, 255, 255, 0.42)',
    chatBg: '#f9fafb',
    messageBg: '#e5e7eb',
    myMessageBg: '#2e7cba',
    myMessageGradient: 'linear-gradient(135deg, #2e7cba 0%, #1a6baa 100%)',
    theirMessageBg: '#e5e7eb',
    inputBg: '#ffffff',
    hoverBg: 'rgba(59, 130, 246, 0.08)',
    text: '#0f172a',
    textSecondary: '#64748b',
    textOnPrimary: '#ffffff',
    bubbleText: '#ffffff',
    border: 'rgba(0, 0, 0, 0.08)',
    inputBorder: 'rgba(0, 0, 0, 0.12)',
    shadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
    softShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
    bubbleShadow: '0 4px 20px rgba(15, 23, 42, 0.10)',
    myBubbleShadow: '0 4px 20px rgba(46, 124, 186, 0.25)',
    glassEffect: 'blur(16px)',
    online: '#22c55e',
    offline: '#94a3b8',
    seenTeal: '#008C8C',
    panelBg: 'rgba(255, 255, 255, 0.42)',
    popoverBg: 'rgba(255, 255, 255, 0.95)',
    popoverBorder: 'rgba(0, 0, 0, 0.1)',
  },
  dark: {
    mainBg: 'rgba(15, 23, 42, 0.95)',
    sidebarBg: 'rgba(15, 23, 42, 0.95)',
    chatBg: 'rgba(30, 41, 59, 0.5)',
    messageBg: 'rgba(71, 85, 105, 0.5)',
    myMessageBg: '#2e7cba',
    myMessageGradient: 'linear-gradient(135deg, #2e7cba 0%, #1a6baa 100%)',
    theirMessageBg: 'rgba(156, 163, 175, 0.35)',
    inputBg: 'rgba(51, 65, 85, 0.8)',
    hoverBg: 'rgba(255, 255, 255, 0.08)',
    text: '#ffffff',
    textSecondary: 'rgba(255, 255, 255, 0.7)',
    textOnPrimary: '#ffffff',
    bubbleText: '#ffffff',
    border: 'rgba(255, 255, 255, 0.08)',
    inputBorder: 'rgba(255, 255, 255, 0.12)',
    shadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
    softShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
    bubbleShadow: '0 4px 20px rgba(0, 0, 0, 0.25)',
    myBubbleShadow: '0 4px 20px rgba(46, 124, 186, 0.35)',
    glassEffect: 'blur(16px)',
    online: '#22c55e',
    offline: '#64748b',
    seenTeal: '#008C8C',
    panelBg: 'rgba(15, 23, 42, 0.95)',
    popoverBg: 'rgba(30, 41, 59, 0.95)',
    popoverBorder: 'rgba(255, 255, 255, 0.12)',
  },
};

export const messengerColors = colors;
export const getColors = (theme) => colors[theme] || colors.light;